import { AdminLayout } from "@/views/layouts/AppLayout";
import { Navigate } from "react-router";
import { ApplicationPage } from "@/views/pages/manageCenter/application/ApplicationPage";
import { ApplicationFormPage } from "@/views/pages/manageCenter/application/ApplicationFormPage";
import { ApplicationDetailPage } from "@/views/pages/manageCenter/application/ApplicationDetailPage";
import { CallbackRecordPage } from "@/views/pages/manageCenter/callbackRecord/CallbackRecordPage";
import { BusinessSettingPage } from "@/views/pages/manageCenter/businessSetting/BusinessSettingPage";
import { OrganizationalStructurePage } from "@/views/pages/systemBackendAccount/organizationalStructure/OrganizationalStructurePage";
import { OrganizationPersonFormPage } from "@/views/pages/systemBackendAccount/organizationalStructure/OrganizationPersonFormPage";
import { SystemBackendAccountPage } from "@/views/pages/systemBackendAccount/list";
import { BackendAccountFormPage } from "@/views/pages/systemBackendAccount/list/BackendAccountFormPage";
import { SystemRolePage } from "@/views/pages/systemBackendAccount/role";
import { RoleFormPage } from "@/views/pages/systemBackendAccount/role/RoleFormPage";
import { RoleDetailPage } from "@/views/pages/systemBackendAccount/role/RoleDetailPage";
import { TagListPage } from "@/views/pages/manageCenter/tagManage/TagListPage";
import { SearchFoundPage } from "@/views/pages/userOperation/searchFound/SearchFoundPage";
import type { AdminRouteObject } from "../index";

/** 平台管理路由，保留 Vue 版本应用管理的层级和权限标识。 */
export const manageCenterRoutes: AdminRouteObject = {
    path: "/manageCenter",
    element: <AdminLayout />,
    handle: { title: "平台管理" },
    children: [
        {
            // 沿用旧 Vue 管理中心入口，打开根路径时默认进入角色管理。
            index: true,
            element: <Navigate replace to="systemManage/role" />
        },
        {
            path: "systemManage",
            handle: { title: "组织用户" },
            children: [
                {
                    path: "organizationalStructure",
                    element: <OrganizationalStructurePage />,
                    // 列表页保留 Vue 的查看、部门管理和员工管理权限。
                    handle: {
                        title: "组织架构",
                        permissions: ["ROLE_ORG_R", "ROLE_DEPT_W", "ROLE_EMPLOYEE_W"]
                    }
                },
                {
                    path: "organizationalStructure/add",
                    element: <OrganizationPersonFormPage />,
                    handle: { title: "新增员工", permissions: ["ROLE_EMPLOYEE_W"] }
                },
                {
                    path: "organizationalStructure/edit/:id",
                    element: <OrganizationPersonFormPage />,
                    handle: { title: "编辑员工", permissions: ["ROLE_EMPLOYEE_W"] }
                },
                {
                    path: "backendAccount",
                    element: <SystemBackendAccountPage />,
                    // 列表页保留查看与管理权限，操作按钮继续由页面细分控制。
                    handle: { title: "后台用户", permissions: ["ROLE_USER_R", "ROLE_USER_W"] }
                },
                {
                    path: "role",
                    element: <SystemRolePage />,
                    // 角色列表保留 Vue 的查看与管理权限组合。
                    handle: { title: "角色管理", permissions: ["ROLE_ROLE_R", "ROLE_ROLE_W"] }
                },
                {
                    path: "backendAccount/add",
                    element: <BackendAccountFormPage />,
                    handle: { title: "新增后台用户", permissions: ["ROLE_USER_W"] }
                },
                {
                    path: "backendAccount/edit",
                    element: <BackendAccountFormPage />,
                    handle: { title: "编辑后台用户", permissions: ["ROLE_USER_W"] }
                },
                {
                    path: "backendAccount/edit/:id",
                    element: <BackendAccountFormPage />,
                    handle: { title: "编辑后台用户", permissions: ["ROLE_USER_W"] }
                },
                {
                    path: "role/add",
                    element: <RoleFormPage />,
                    handle: { title: "新增角色", permissions: ["ROLE_ROLE_W"] }
                },
                {
                    path: "role/detail",
                    element: <RoleDetailPage />,
                    handle: { title: "角色详情", permissions: ["ROLE_ROLE_R"] }
                },
                {
                    path: "role/detail/:id",
                    element: <RoleDetailPage />,
                    handle: { title: "角色详情", permissions: ["ROLE_ROLE_R"] }
                },
                {
                    path: "role/edit",
                    element: <RoleFormPage />,
                    handle: { title: "编辑角色", permissions: ["ROLE_ROLE_W"] }
                },
                {
                    path: "role/edit/:id",
                    element: <RoleFormPage />,
                    handle: { title: "编辑角色", permissions: ["ROLE_ROLE_W"] }
                }
            ]
        },
        {
            path: "appManagement",
            handle: { title: "应用管理" },
            children: [
                {
                    path: "application",
                    element: <ApplicationPage />,
                    handle: { title: "应用管理", permissions: ["ROLE_APPLICATION"] }
                },
                {
                    path: "applicationEdit/:id",
                    element: <ApplicationFormPage />,
                    handle: { title: "编辑应用", permissions: ["ROLE_APPLICATION"] }
                },
                {
                    path: "applicationAdd",
                    element: <ApplicationFormPage />,
                    handle: { title: "新增应用", permissions: ["ROLE_APPLICATION"] }
                },
                {
                    path: "applicationDetail/:id",
                    element: <ApplicationDetailPage />,
                    handle: { title: "应用详情", permissions: ["ROLE_APPLICATION"] }
                },
                {
                    path: "callbackRecord",
                    element: <CallbackRecordPage />,
                    handle: { title: "回调记录", permissions: ["ROLE_CALLBACK_RECORD"] }
                }
            ]
        },
        {
            path: "businessSetting",
            element: <BusinessSettingPage />,
            handle: { title: "业务设置", permissions: ["ROLE_PROMO_SETTINGS"] }
        },
        {
            path: "tagManage/tagList",
            element: <TagListPage />,
            // 标签列表需要管理权限才能展示新增、编辑和禁用操作。
            handle: { title: "标签列表", permissions: ["ROLE_LABEL_R", "ROLE_LABEL_W"] }
        },
        {
            path: "tagManage/searchFound",
            element: <SearchFoundPage />,
            handle: { title: "搜索发现", permissions: ["ROLE_SEARCH_R", "ROLE_SEARCH_W"] }
        }
    ]
};

export default manageCenterRoutes;
